import React from 'react';
import { File, AlertCircle } from '@lifeomic/chromicons';
import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { useTemplatingItemTypeDisplay } from '../../hooks';

import { ICON_MAP } from '../../ImpressionTypeFilter';
import { TemplateNotFound, TemplateSummary } from '../../models';
import { theme } from '../../../../theme/phc';

const useStyles = makeStyles(theme => ({
  fileIcon: {
    marginRight: theme.spacing(1),
  },
  dotLoader: {
    width: 16,
  },
}));

type IconComponentProps = Pick<
  React.SVGProps<SVGSVGElement>,
  'width' | 'height' | 'fill' | 'color'
>;

interface TemplateIconProps extends IconComponentProps {
  isGenerating?: boolean;
  template: TemplateSummary | TemplateNotFound;
}

const TemplateIcon: React.FC<TemplateIconProps> = ({
  isGenerating = false,
  template,
  ...props
}) => {
  const styles = useStyles();
  const templatingItemTypeDisplay = useTemplatingItemTypeDisplay();

  let Icon: React.ComponentType<IconComponentProps> = File;
  let color: string | undefined = undefined;

  if (template.type === 'template') {
    Icon = ICON_MAP[template?.impressionType ?? 'general'] ?? File;
  } else {
    Icon = AlertCircle;
    color = theme.palette.error.main;
  }

  return (
    <span
      className={styles.fileIcon}
      role="img"
      aria-label={templatingItemTypeDisplay.template}
    >
      {isGenerating ? (
        <DotLoader size={0} className={styles.dotLoader} />
      ) : (
        <Icon width={20} height={20} color={color} {...props} />
      )}
    </span>
  );
};

export { TemplateIcon };
